module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAABaklEQVQ4T82Uv0oDQRDGv1kxReQCtj6ClcKlUuwVAwqmtbQyURARNHdeQk5ULEStfAQ7TUinjVoowRQ+gI1YKniiaPBG9uCOmHjJrRJwq2Vn5sf8248QcuaLpZo0HeRSwz+5tLOTDEhbR7GB3niBgTkA/Xtrk5Qpllja9nMpytpl7+6fEPsTAYcP9VfTgy7Y5U0GVjoEdYJ6dgK2PGjWLj/KDAWJ0d3ViUv5plr+4kZlxGX3AoDM2IN65cmywnoc5d3ndBfK/G0WURIL9Qky7Qr0X/Q0oefH6z18+3Zl3ft9+NOgND2/DdAygGOnak6pQQetmBYX6yzo9OXaOJPBPpCBDwGafq4aFSVoX9IeEvxZY6Z3YsxAuGMyQwkkUNqpGieNKxC5fC2Z3wHTEhguCCIM2PiJIi2/D24HVIbKgIRemGUXd86NeR629ZHLV/lazdAWlVKBSd8WlWrWU1Vgo3+gp83K/0tooPxfMNT2EQ40iHAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reserve.png
// module id = HU6e
// module chunks = 1